/**
 * Overlay choix tour joker — même structure que le dépassement (VS),
 * avec libellé vertical au centre et deux options cliquables.
 */
export class JokerLapChoiceOverlay {
  private wrapper: HTMLDivElement | null = null;
  private onChoice: ((enter: boolean) => void) | null = null;
  private visible = false;

  constructor(container: HTMLElement) {
    this.createUI(container);
  }

  private createUI(container: HTMLElement): void {
    const wrapper = document.createElement('div');
    wrapper.id = 'joker-lap-choice-overlay';
    wrapper.className = 'overtake-overlay joker-lap-choice-overlay';
    wrapper.setAttribute('role', 'dialog');
    wrapper.setAttribute('aria-modal', 'true');
    wrapper.setAttribute('aria-label', 'Choix tour joker');
    wrapper.hidden = true;

    const inner = document.createElement('div');
    inner.className = 'overtake-overlay-inner joker-lap-choice-inner';

    const panel = document.createElement('div');
    panel.className = 'overtake-vs-panel joker-lap-choice-panel';

    const mainBtn = document.createElement('button');
    mainBtn.type = 'button';
    mainBtn.className = 'joker-lap-choice-side joker-lap-choice-side--main overtake-side';
    mainBtn.innerHTML = `
      <span class="joker-lap-choice-icon" aria-hidden="true">
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 36 L24 12 L40 36" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14 36 L34 36" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
        </svg>
      </span>
      <span class="joker-lap-choice-title">Circuit principal</span>
      <span class="joker-lap-choice-desc">Rester sur le tracé habituel</span>`;
    mainBtn.addEventListener('click', () => this.pick(false));

    const center = document.createElement('div');
    center.className = 'joker-lap-choice-label';
    center.setAttribute('aria-hidden', 'true');
    center.innerHTML = `
      <span class="joker-lap-choice-label-word">Choix</span>
      <span class="joker-lap-choice-label-word">tour</span>
      <span class="joker-lap-choice-label-word joker-lap-choice-label-word--accent">joker</span>`;

    const branchBtn = document.createElement('button');
    branchBtn.type = 'button';
    branchBtn.className = 'joker-lap-choice-side joker-lap-choice-side--branch overtake-side';
    branchBtn.innerHTML = `
      <span class="joker-lap-choice-icon" aria-hidden="true">
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 36 L20 20 L20 12 L28 12 L28 20 L40 36" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14 36 L34 36" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
        </svg>
      </span>
      <span class="joker-lap-choice-title">Tour joker</span>
      <span class="joker-lap-choice-desc">Emprunter la branche alternative</span>`;
    branchBtn.addEventListener('click', () => this.pick(true));

    panel.append(mainBtn, center, branchBtn);
    inner.append(panel);
    wrapper.append(inner);
    container.appendChild(wrapper);
    this.wrapper = wrapper;
  }

  private pick(enter: boolean): void {
    const cb = this.onChoice;
    this.hide();
    cb?.(enter);
  }

  show(onChoice: (enter: boolean) => void): void {
    if (!this.wrapper || this.visible) return;
    this.onChoice = onChoice;
    this.visible = true;
    this.wrapper.hidden = false;
    this.wrapper.classList.add('is-visible');
    this.wrapper.classList.remove('is-entered');
    requestAnimationFrame(() => {
      this.wrapper?.classList.add('is-entered');
    });
  }

  hide(): void {
    if (!this.wrapper) return;
    this.visible = false;
    this.onChoice = null;
    this.wrapper.classList.remove('is-visible', 'is-entered');
    this.wrapper.hidden = true;
  }

  isVisible(): boolean {
    return this.visible;
  }

  destroy(): void {
    this.hide();
    this.wrapper?.remove();
    this.wrapper = null;
  }
}
